import { type ChildMachineConfig, ParentState } from "@hopper-b2b/checkout";
import { ActionTypes } from "./actions";
import { RewardsPaymentEventTypes } from "./events";
import { RewardsPaymentInformationState } from "./types";

export const getMachineState = (config: ChildMachineConfig) => ({
  id: ParentState.awardsPayment,
  initial: RewardsPaymentInformationState.idle,
  states: {
    [RewardsPaymentInformationState.idle]: {
      on: {
        [RewardsPaymentEventTypes.SET_REWARDS_AMOUNT_TO_APPLY]: {
          actions: [
            ActionTypes.setRewardsAmountToApply,
            ActionTypes.calculateRewardsAmountCashEquivalent,
          ],
        },
      },
    },
    [RewardsPaymentInformationState.error]: {
      on: {
        [RewardsPaymentEventTypes.CLEAR_REWARDS_PAYMENT_ERROR]: {
          target: `#${config.parentMachineId}.${ParentState.awardsPayment}.${RewardsPaymentInformationState.idle}`,
        },
      },
    },
  },
  on: {
    [RewardsPaymentEventTypes.PREVIOUS]: {
      target: config.previousState,
    },
    [RewardsPaymentEventTypes.NEXT]: {
      target: config.nextState,
    },
    [RewardsPaymentEventTypes.SET_REWARDS_AMOUNT_TO_APPLY]: {
      actions: [
        ActionTypes.setRewardsAmountToApply,
        ActionTypes.calculateRewardsAmountCashEquivalent,
      ],
    },
    [RewardsPaymentEventTypes.SET_REWARDS_SELECTED]: {
      actions: ActionTypes.setRewardsSelected,
    },
    [RewardsPaymentEventTypes.SET_REWARDS_ACCOUNT_ID]: {
      actions: ActionTypes.setRewardsAccountId,
    },
    [RewardsPaymentEventTypes.SET_BASED_FARE_FIXED_PRICE]: {
      actions: ActionTypes.setBasedFareFixedPrice,
    },
    [RewardsPaymentEventTypes.CLOSE_ADDITIONAL_POINTS_NOT_ELIGIBLE_MODAL]: {
      actions: ActionTypes.closeAdditionalPointsNotEligibleModal,
    },
    [RewardsPaymentEventTypes.SET_POINTS_REDEMPTION]: {
      // Store the BE brackets, then recompute the displayed cash equivalent so
      // the chooser and Price Breakdown stay in sync when the quote re-quotes.
      actions: [
        ActionTypes.setPointsRedemption,
        ActionTypes.calculateRewardsAmountCashEquivalent,
      ],
    },
    [RewardsPaymentEventTypes.SET_POINTS_TO_CASH_LOADING]: {
      actions: ActionTypes.setPointsToCashLoading,
    },
  },
});
